export type CategoryPreset = { id: string; name: string; cats: any[]; capacity?: number | '' };

const keyFor = (accountId?: string | null) => {
  const id = accountId || (typeof window !== 'undefined' ? (sessionStorage.getItem('activeAccountId') || localStorage.getItem('accountId')) : null) || 'global';
  return `ticketCategoryPresets:${id}`;
};

export const loadPresets = (accountId?: string | null): CategoryPreset[] => {
  try {
    const key = keyFor(accountId);
    if (typeof window === 'undefined') return [];
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

export const savePresets = (arr: CategoryPreset[], accountId?: string | null) => {
  try {
    const key = keyFor(accountId);
    if (typeof window === 'undefined') return;
    localStorage.setItem(key, JSON.stringify(arr));
  } catch (e) {
    // ignore
  }
};

export const addPreset = (preset: CategoryPreset, accountId?: string | null) => {
  const arr = loadPresets(accountId);
  arr.push(preset);
  savePresets(arr, accountId);
};

export const deletePreset = (id: string, accountId?: string | null) => {
  const arr = loadPresets(accountId).filter(p => p.id !== id);
  savePresets(arr, accountId);
};
